<template>
  <div class="skeleton-d-locus">
    <!-- alpha -->
    <div class="skel-d-locus-row-alpha">
      <fts-skeleton height="24px" width="70%" />
    </div>
    <!-- beta -->
    <div class="skel-d-locus-row-beta">
      <div class="skel-d-locus-row-beta-l">
        <fts-skeleton height="14px" width="60%" />
      </div>
      <div class="skel-audit">
        <fts-skeleton size="20px" avatar class="skel-audit-profile" />
        <fts-skeleton height="14px" width="42px" />
      </div>
    </div>
    <!-- gamma -->
    <div class="skel-d-locus-row-gamma">
      <div class="skel-audit">
        <fts-skeleton size="20px" avatar class="skel-audit-profile" />
        <fts-skeleton height="14px" width="56px" />
      </div>
    </div>
  </div>
</template>

<script>
import FTSSkeleton from "../FTSSkeletonScreen";

export default {
  components: {
    "fts-skeleton": FTSSkeleton,
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.skeleton-d-locus {
  .skel-d-locus-row-alpha {
    margin-bottom: .375rem;
  } 
  .skel-d-locus-row-beta {
    display: flex;
    align-items: center;
    margin-bottom: .275rem;
    .skel-d-locus-row-beta-l {
      flex: 1 1 60%
    }
  } 
  .skel-audit {
    display: flex;
    align-items: center;
    .skel-audit-profile {
      margin-right: .275rem;
    }
  }
}
</style>